import Container from "./Container";
import Text from "./Text";
import emptyWallet from "../assets/images/empty_wallet.png";
import { Image } from 'primereact/image';

const EmptyWallet = () => {
    return (
        <Container center fullWidth flexColumn className="pb-4">
            <Image src={emptyWallet} alt="Carteira vazia" className="m-0 p-0" width="200" />
            <Text size="2xl" color="400">Sua carteira está vazia</Text>
        </Container>
    )
}

export default EmptyWallet;
